import styled, {css} from 'styled-components'
import {Separator} from '@radix-ui/react-dropdown-menu'

export const StyledIcon = styled.div`
    cursor: pointer;
    position: relative;
`

export const StyledMenu = styled.div`
    ${({theme: {colors, shadows, zIndex}}) => css`
        border: 1px solid ${colors.transparentBlack};
        border-radius: 8px;
        box-shadow: ${shadows.grey};
        z-index: ${zIndex.dropdownMenu};
    `}
`
export const StyledMenuItem = styled.div`
    ${({theme: {spacing, colors, typography, palette}}) => css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: ${spacing * 4}px;
        padding: ${spacing * 3}px ${spacing * 6}px;
        background: ${palette.neutral.white};
        ${typography.textSm};
        font-weight: 500;
        color: ${palette.neutral.black};
        cursor: pointer;
        &:first-child {
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
        }
        &:last-child {
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
        }
        &:hover {
            background: ${colors.lightGrey};
        }
        &:focus-visible {
            outline: none;
            background: ${colors.lightGrey};
        }
    `}
`

export const StyledMenuSeparator = styled(Separator)`
    ${({theme: {palette}}) => css`
        height: 1px;
        background: ${palette.neutral[300]};
    `}
`
